<template>
  <div class="content">
    <a-spin :spinning="spinning">
      <div class="tree newtree">
        <div class="htit">权限
          <a-icon type="plus-circle" style="margin-right:10px;font-size:16px;" @click="()=> append({id:0,'tit':'基础信息同级',parent_id:0})" />
          <b> 权限所属:
            <a-select v-model="nForm.belong" placeholder="请选择" style="margin-left:10px;" @change="init">
              <a-select-option :value="1">基础</a-select-option>
              <a-select-option :value="2">原告</a-select-option>
            </a-select>
          </b>
        </div>
        <div class="list" v-if='!spinning'>
          <a-tree :tree-data="treeData" :replace-fields="replaceFields" :show-line='true' :show-icon="true" :default-expand-all="autoExpandParent">
            <template slot="btns" slot-scope="item">
              <label style="margin-right:20px;" @click="()=> getInfo(item)" @mouseenter="hoverCode=item.id">
                <span> {{ item.title}}</span>
              </label>
              <a-icon type="plus-circle" style="margin-right:10px;font-size:16px;" @click="()=> append(item)" v-if='hoverCode==item.id' />
              <a-icon type="edit" style="color:#00f;font-size:16px;margin-right:10px;" @click="()=> doedit(item)" v-if='hoverCode==item.id' />
              <a-icon type="minus-circle" style="color:#f00;font-size:16px;" @click="()=> del(item)" v-if='hoverCode==item.id' />
            </template>
          </a-tree>
        </div>
      </div>
      <div class="conmain">
        <div class="see" :class='{"rd":info.id<0}'>
          {{info.id<0?'当前未选择编辑节点':see}}
        </div>
        <div class="edit">
          <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{ span: 3 }" :wrapper-col="{ span: 14 }">
            <a-form-model-item label="权限名称" prop="title">
              <a-input v-model="form.title" :disabled="status==0" />
            </a-form-model-item>
            <a-form-model-item label="权限代码" prop="code">
              <a-input v-model="form.code" :disabled="status==0" />
            </a-form-model-item>
            <a-form-model-item label="权限父级">
              <a-tree-select  v-model="form.parent_id" :disabled="status==0"  show-search  style="width: 100%" :tree-data="treeData" :showCheckedStrategy="SHOW_ALL" :replace-fields=" {
               children: 'child',
               title: 'title',
               key: 'id',
               value: 'id'
              }" allow-clear />
            </a-form-model-item>
            
            <a-form-model-item label="权限类型" prop="type">
              <a-select v-model="form.type" placeholder="请选择" :disabled="status==0">
                <a-select-option :value="1">菜单</a-select-option>
                <a-select-option :value="2">操作</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="排序" prop="sort">
              <a-input-number v-model="form.sort" :min="1" :max="50" :disabled="status==0" />
            </a-form-model-item>
            <a-form-model-item label="接口路径" prop="router">
              <a-input v-model="form.router" :disabled="status==0" />
            </a-form-model-item>
            <a-form-model-item label="状态" prop="status">
              <a-switch checked-children="启用" un-checked-children="禁用" default-checked v-model='form.status' :disabled="status==0" />
            </a-form-model-item>
            <a-form-model-item label="特殊参数" prop="view_param">
              <a-input v-model="form.view_param" :disabled="status==0" />
            </a-form-model-item>
            <a-form-model-item label="权限描述" prop="merge_title">
              <a-input v-model="form.merge_title" :disabled="status==0" />
            </a-form-model-item>
          </a-form-model>
          <div class="see">
            当前提交数据{{form}}
          </div>
          <div class="buttons" v-if='status>0'>
            <a-button type='primary' @click='sub'>保存</a-button>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import { list, setPower, powerDel } from './api'
import { TreeSelect } from 'ant-design-vue';
export default {
  data() {
    return {
      ischecked: false,
      status: 0,   //状态  1新增 2编辑 
      info: {
        id: -1
      },
      nForm: {
        belong: 1,
        status: 1
      },
      autoExpandParent:false,
      form: {
        status: true,
      },
      rules: {
        title: { required: true, message: '请输入权限名称', trigger: 'blur' },
        code: { required: true, message: '请输入权限代码', trigger: 'blur' },
        type: { required: true, message: '请选择权限类型', trigger: 'blur' },
        merge_title: { required: true, message: '请选择权限描述', trigger: 'blur' },
      },
      spinning: true,
      treeData: [],
      hoverCode: '',
      SHOW_ALL: TreeSelect.SHOW_ALL,
      parentNode:[],
      replaceFields: {
        children: 'child',
        title: 'title',
        key: 'id'
      },
    }
  },
  computed: {
    see() {
      return '当前标记' + JSON.stringify({
        id: this.info.id,
        pid: this.info.parent_id,
        title: this.info.merge_title  
      })
    }
  },
  created() {
  //  this.spinning = false;
    this.init();
  },
  methods: {
    reset() {
      this.form = {
        status: true,
      }
      this.info = { id: -1 }
    },
    append(data) {
      this.reset()
      this.status = 1;
      this.info = data
      this.form.parent_id=data.id
    },
    doedit(data) {
      this.reset()
      this.status = 2;
      this.info = data
      this.form = {
        id:data.id,
        title: data.title,
        code: data.code,
        type: data.type,
        status: data.status == 1 ? true : false,
        view_param: data.view_param,
        merge_title: data.merge_title,
        router: data.router,
        parent_id:data.parent_id,
        sort:data.sort
      }
    },
    del(data) {
      this.$modal.confirm({
        title: '确定删除该权限菜单？',
        cancelText: "取消",
        okText: "确定",
        onOk: () => {
          powerDel(data.id).then(e => {
            this.$message.success('已删除对应权限菜单')
            this.init()
            this.reset()
          })
        }
      });
    },
    getInfo(e) {
      this.doedit(e)
      this.status = 0
    },
    init() { //初始化
      this.reset()
      this.spinning = true;
      list(this.nForm).then(e => {
        let s = this.jsons(e)
        this.treeData = s;
        this.spinning = false;
      })
    },
    jsons(data) {
      for (let val of data) {
        val.scopedSlots = { "title": "btns" };
        if (val.child) {
          this.jsons(val.child)
        }
      }
      return data
    },
    sub() {
      if (this.info.id < 0) {
        return false;
      }
      this.$refs.forms.validate(valid => {
        let form = JSON.parse(JSON.stringify(this.form))
        if (valid) {
          //   form.parent_id = this.info.id;
          form.belong = this.nForm.belong
          if (this.status == 2) {
            form.id = this.info.id;
            form.parent_id = form.parent_id
          }
          if (this.status == 1) {
            form.parent_id = this.info.id;
          }
          if(!form.parent_id){  //一级
            form.parent_id=0
          }
          form.status = form.status ? 1 : 0
          setPower(form, this.status).then(e => {
            this.$message.success('已设置权限')
            this.init()
            this.reset()
          })
        }
      })

    }
  }
}
</script>
<style lang="less">
.newtree {
  .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background: none;
  }
}
</style>
<style lang="less" scoped>
.content {
  padding: 20px;
  width: 1300px;
  margin: 0 auto; // overflow: hidden;
}
.tree {
  width: 392px;
  float: left;
  .btns {
    a {
      display: inline-block;
      width: 88px;
      line-height: 30px;
      border: 1px solid #333;
      border-radius: 6px;
      text-align: center;
      color: #333;
    }
    .act {
      color: #1890ff;
      border-color: #1890ff;
    }
  }
  .htit {
    width: 392px;
    line-height: 68px;
    text-indent: 30px;
    font-size: 1.25rem;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    background: rgba(238, 238, 238, 1);
    border-radius: 4px 4px 0px 0px;
    display: flex;
    align-items: center;
    b {
      display: flex;
      align-items: center;
      font-size: 0.875rem;
    }
  }
  .btns {
    padding: 10px 40px;
    display: flex;
    justify-content: space-between;
  }
  .list {
    padding: 20px 30px;
    background: #fff;
    height: 628px;
  }
}
#editorsay {
  height: 400px;
}
.conmain {
  .see {
    line-height: 60px;
    margin-bottom: 20px;
    background: #1890ff;
    color: #fff;
    padding-left: 20px;
  }
  .rd {
    background: #f00;
  }
  float: right;
  width: 840px;
  height: 100%;
  position: relative;
  .input {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    label {
      width: 50px;
    }
  }
  .buttons {
    margin-top: 60px;
    padding-left: 100px;
  }
}
</style>